import { ArrowLeft, ArrowRight, Send } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import type { WizardStep } from '../types'
import { WIZARD_STEPS } from './wizardSteps'

type Props = {
  step: WizardStep
  onBack: () => void
  onNext: () => void
  onPublish: () => void
}

export function WizardNav({ step, onBack, onNext, onPublish }: Props) {
  const { t } = useTranslation()
  const isLast = step >= WIZARD_STEPS.length

  return (
    <div className="flex items-center justify-between gap-2 pt-1">
      {step > 1 ? (
        <Button type="button" variant="outline" onClick={onBack}>
          <ArrowLeft />
          {t('common.back')}
        </Button>
      ) : (
        <span />
      )}
      {isLast ? (
        <Button type="button" onClick={onPublish}>
          <Send />
          {t('hr.belgeler.publish.action')}
        </Button>
      ) : (
        <Button type="button" onClick={onNext}>
          <span className="sm:hidden">{t('hr.belgeler.wizard.nextShort')}</span>
          <span className="hidden sm:inline">{t(`hr.belgeler.wizard.next.${step}`)}</span>
          <ArrowRight />
        </Button>
      )}
    </div>
  )
}
